export default __webpack_public_path__ + "static/media/debunking.fd63048e.png";